'use strict';exports.__esModule = true;var PREFERRED_COUNTRIES = ['il', 'gb', 'ua', 'fr', 'ru'];

var AIMS = ['get_info', 'make_appointment'];

var MESSENGERS = ['viber', 'whats_up', 'telegram'];exports.

PREFERRED_COUNTRIES = PREFERRED_COUNTRIES;exports.AIMS = AIMS;exports.MESSENGERS = MESSENGERS;


//////////////////
// WEBPACK FOOTER
// ./src/containers/PropertyDetailedContactsUsForm/constants.js
// module id = 1252
// module chunks = 0